import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const routes = [];

const router = new VueRouter({
  mode: process.env.NODE_ENV === "production" ? "history" : "history",

  base: process.env.NODE_ENV === "production" ? "/march_madness_2020/" : "/",

  routes
});

export default router;
